// import SharePointService from './sharepointService';

import CandidateStateService from "./candidateStateService";
import GlobalStateService from "./globalStateService";
export const globalStateService = new GlobalStateService();
export const candidateStateService = new CandidateStateService();